export const DATASET_GENERATION_MIN_DIALOGS = 1;
export const DATASET_GENERATION_MAX_DIALOGS = 100;
export const DATASET_GENERATION_MIN_MESSAGES_PER_DIALOG = 1;
export const DATASET_GENERATION_MAX_MESSAGES_PER_DIALOG = 50;

export const UNIT_RATIO_MIN = 0;
export const UNIT_RATIO_MAX = 1;
export const UNIT_RATIO_STEP = 0.1;

export const HISTORY_DEPTH_MIN = 1;
export const HISTORY_DEPTH_MAX = 20;
